import { ISnotrRoute } from '..';

export default [
  {
    path: '/company-settings',
    name: 'CompanySettings',
    meta: {
      title: 'TabTitle.companySettings',
    },
    component: () => import('@/pages/company-settings.vue'),
  },
] as ISnotrRoute[];
